const route = [
  {
    path: '/personalTask/list/:tenant',
    name: 'task',
    component: () => import('@/views/personalTask/index'),
    meta: { routeName: '个人待办' }
  }
]
export default route
